export default __webpack_public_path__ + "521a62b17066cd1b444027d8cb56210c.png";